console.log('Hello, world')
